import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

import { expValEquals } from '@confluence/feature-experiments';

import {
	type ContentAppearanceToAtlaskitMap,
	type FullPageAppearances,
	ContentAppearanceType,
} from './contentAppearanceTypes.ts';

const _contentAppearanceToAtlaskitMap: ContentAppearanceToAtlaskitMap = {
	[ContentAppearanceType.DEFAULT]: 'full-page',
	[ContentAppearanceType.FULL_WIDTH]: 'full-width',
	[ContentAppearanceType.MAX]: 'max',
};

export const getContentAppearanceForAtlaskit: MemoizedFn<
	(contentAppearance: ContentAppearanceType) => FullPageAppearances
> = memoizeOne((contentAppearance: ContentAppearanceType): FullPageAppearances => {
	const appearanceForAtlaskit = _contentAppearanceToAtlaskitMap[contentAppearance];

	// Fallback to 'full-width' if 'max' and experiment is off
	if (
		appearanceForAtlaskit === 'max' &&
		!expValEquals('editor_tinymce_full_width_mode', 'isEnabled', true) &&
		!expValEquals('confluence_max_width_content_appearance', 'isEnabled', true)
	) {
		return 'full-width';
	}

	if (appearanceForAtlaskit) {
		return appearanceForAtlaskit;
	}
	return getDefaultContentAppearanceForAtlaskit();
});

export const getDefaultContentAppearanceForAtlaskit = (): FullPageAppearances => {
	return _contentAppearanceToAtlaskitMap[ContentAppearanceType.DEFAULT];
};
